<template>
  <div class="question-radio">
    <vp-radio-buttons
        :id="id"
        ref="input"
        v-model="selected"
        :options="options"
      />
  </div>
</template>

<script>
export default {
  name: 'question-radio',
  props: {
    id: String,
    options: Array,
    value: String,
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    defaultValue() {
      const selected = this.value || this.options[0]?.value;
      return selected;
    },
  },
  mounted() {
    this.selected = this.defaultValue;
  },
  watch: {
    value(newVal) {
      if (newVal !== this.selected) {
        this.selected = newVal || this.options[0]?.value;
      }
    },
    selected(newVal) {
      if (newVal !== this.value) {
        this.$emit('input', newVal);
      }
    },
  },
};
</script>

<style scoped>
  .question-radio {
    margin-top: 20px;
  }
</style>
